var constraints = {
  blog: {
    title: {
      length: {
        min: 5,
        max: 32
      }
    },
    lead: {
      length: {
        min: 20,
        max: 500
      }
    },
    body: {
      length: {
        min: 20,
        max: 64000
      }
    }
  },
  comment: {
    title: {
      length: {
        min: 5,
        max: 32
      }
    },
    lead: {
      length: {
        min: 20,
        max: 500
      }
    }
  },
  user: {
    nick: {
      regex: /^\w[\w \-\(\)_]+[\w\)\]]+$/,
      length: {
        min: 3,
        max: 16
      }
    },
    pasword: {
      length: {
        min: 8,
        max: 32
      }
    }
  }
};
export default constraints;